// extracted by mini-css-extract-plugin
export default {"inputBlock":"ChangeSettingsBlock_inputBlock__VLLEQ","notice":"ChangeSettingsBlock_notice__30XTe"};